import React from 'react';
import styles from './Menu.module.scss';
import Flex from '../../Flex/Flex';
import MenuItem, { MenuItemShape } from './MenuItem';
import { LinkAdapter } from '../../Link/Link';

export interface MenuShape {
  menuItems?: MenuItemShape[];
  onMenuItemClick?: (
    e: React.MouseEvent<HTMLDivElement>,
    id: string,
    level: number,
    locked: boolean,
    url?: string
  ) => void;
  forMobile?: boolean;
  level?: number;
  linkAdapter?: LinkAdapter;
  isOpen?: boolean;
}

const Menu: React.FunctionComponent<MenuShape> = ({
  menuItems,
  onMenuItemClick,
  forMobile,
  level = 1,
  linkAdapter,
  isOpen = false,
}) => {
  return menuItems ? (
    <Flex className={[styles.menu, styles[`menu__level${level}`]]}>
      {menuItems.map((menuItem) => (
        <MenuItem
          data-testid="menuItem"
          menuComponent={Menu}
          {...menuItem}
          level={level}
          key={menuItem.id}
          onMenuItemClick={onMenuItemClick}
          forMobile={forMobile}
          linkAdapter={linkAdapter}
          tabbable={isOpen || level === 1}
        />
      ))}
    </Flex>
  ) : null;
};

export default Menu;
